import { useRef } from 'react';
import { getMicLevel, useMicFrame, useMicState } from '../core/mic';
import { levelPct } from '../core/util';
import { Icon } from '../ui/icons';
import { openMicSetup } from './uiState';

/** Header button showing the microphone state and level; opens the mic dialog. */
export function MicChip({ compact }: { compact?: boolean }) {
  const st = useMicState();
  const fill = useRef<HTMLSpanElement>(null);
  useMicFrame(() => {
    if (fill.current) fill.current.style.width = `${Math.round(levelPct(getMicLevel()))}%`;
  });
  return (
    <button
      type="button"
      className={`mic-chip${compact ? ' compact' : ''}`}
      data-state={st}
      aria-label="Mikrofon ayarları"
      onClick={openMicSetup}
    >
      <Icon name="mic" />
      <span className="mc-txt">{st === 'on' ? 'Dinliyor' : st === 'starting' ? 'Açılıyor' : 'Mikrofon'}</span>
      <span className="mc-lvl">
        <span className="mc-lvl-fill" ref={fill} />
      </span>
      <span className="mc-dot" />
    </button>
  );
}
